import { computed, watch } from "vue";
import { u as useThrottleProps, a as useThrottleValue } from "../../../composables/useThrottle.js";
const useFilterableProps = {
  ...useThrottleProps,
  filter: { type: String, default: "" },
  filterMethod: { type: Function }
};
const useFilterable = (rawRows, props, emit) => {
  const filteredRows = computed(() => {
    if (!rawRows.value.length) {
      return rawRows.value;
    }
    if (props.filter === "" && !props.filterMethod) {
      return rawRows.value;
    }
    return rawRows.value.filter(
      (row) => row.cells.some((cell) => {
        if (typeof props.filterMethod === "function") {
          return props.filterMethod(cell.source, cell);
        }
        const cellRegex = new RegExp(props.filter, "i");
        return cellRegex.test(cell.value);
      })
    );
  });
  const filteredRowsThrottled = useThrottleValue(filteredRows, props);
  watch(filteredRowsThrottled, () => {
    emit("filtered", {
      items: filteredRowsThrottled.value.map((row) => row.source),
      itemsIndexes: filteredRowsThrottled.value.map((row) => row.initialIndex)
    });
  });
  if (filteredRows.value.length !== rawRows.value.length) {
    emit("filtered", {
      items: filteredRows.value.map((row) => row.source),
      itemsIndexes: filteredRows.value.map((row) => row.initialIndex)
    });
  }
  return {
    filteredRows: filteredRowsThrottled
  };
};
export {
  useFilterable as a,
  useFilterableProps as u
};
//# sourceMappingURL=useFilterable.js.map
